import Checkbox from '@material-ui/core/Checkbox';
import Paper from '@material-ui/core/Paper';
import { lighten, makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import Accordion from '@material-ui/core/Accordion';
import AccordionSummary from '@material-ui/core/AccordionSummary';
import AccordionDetails from '@material-ui/core/AccordionDetails';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';
import TableSortLabel from '@material-ui/core/TableSortLabel';
import Toolbar from '@material-ui/core/Toolbar';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import DeleteIcon from '@material-ui/icons/Delete';
import MoreHorizIcon from '@material-ui/icons/MoreHoriz';
import RefreshIcon from '@material-ui/icons/Refresh';
import SortIcon from '@material-ui/icons/Sort';
import Select from '@material-ui/core/Select';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import clsx from 'clsx';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import basePCUrl from '../../../Globals';
import { DateCreateTimeStamp } from './../DateCreate/DateCreateTimeStamp';
import { postApiData } from '../../../utils/service';
import { useQuery } from 'react-query';

var baseUrl = basePCUrl + 'Alerts/GetCompanyAlerts';

const AdminTrainingTableCollapsible = (props) => {
  const [selected, setSelected] = React.useState([]);
  const [selectedAndDeleted, setSelectedAndDeleted] = useState([]);
  const [deleteLoading, setDeleteLoading] = useState(false);
  //const [open, setOpen] = React.useState(false);

  const [toBeDeleted, setToBeDeleted] = useState({});
  //const [deleted, setDeleted] = useState(false);

  const preferredLanguage = props.preferredLanguage;
  const getTranslation = props.getTranslation;



  const mobileCheck = useMediaQuery('(min-width:830px)');

  function getAllAlertIds(data) {
    const alertIds = [];

    // Iterate over each object in the data array
    data.forEach((item) => {
      // Iterate over the data array within each object
      item.data.forEach((innerItem) => {
        // Push the alertId to the alertIds array
        alertIds.push(innerItem.alertId);
      });
    });

    return alertIds;
  }

  //----------Table Logic---------//

  const [sortByProperty, setSortByProperty] = useState('userName');
  const handleSortByChange = (event) => {
    setSortByProperty(event.target.value);
  };

  const createArrayOfObjectsForSorting = (data, property) => {
    // Initialize an empty object to store data by properties
    const result = {};

    // Iterate over each object in the data array
    data.forEach((item) => {
      // Extract the value of the specified property from the current object
      const propertyValue = item[property];

      // Check if the property value already exists in the result object
      if (result.hasOwnProperty(propertyValue)) {
        // If it exists, push the current item to the array under that property value
        result[propertyValue].data.push(item);
      } else {
        // If it doesn't exist, create a new object with the current item in the 'data' property
        result[propertyValue] = { username: propertyValue, data: [item] };
      }
    });

    // Transform the result object into an array of objects
    const arrayOfObjects = Object.values(result);

    return arrayOfObjects;
  };

  const userTrainingData = props.userTrainingData;

  //console.log(props.trainingModules?.trainingItems);

  const sortedRows = createArrayOfObjectsForSorting(userTrainingData, sortByProperty);
  let rows = sortedRows;

  //console.log(rows);
  //const sortByUserName = createArrayOfObjectsForSorting(alertsData, 'userName');

  //----------logic for conditional color fill on first column's table data-------//

 
  const capitalizeSeverity = (value) => {
    return value.toUpperCase();
  };


  const accountForUserLength = (linkForCheck) => {
    if (linkForCheck != null && linkForCheck.length >= 15 && mobileCheck === false) {
      //var name = linkForCheck.indexOf('@');
      //return <span>{linkForCheck.substring(0, name != -1 ? name : linkForCheck.length)}</span>
      return <span>{linkForCheck.slice(0, 15)} ...</span>;
    } else {
      return <span id="alertsLinkNormal">{linkForCheck}</span>;
    }
  };


  ////------Normal Sorting Logic------////
  function desc(a, b, orderBy) {
    if (b[orderBy] < a[orderBy]) {
      return -1;
    }
    if (b[orderBy] > a[orderBy]) {
      return 1;
    }
    return 0;
  }

  function stableSort(array, cmp) {
    const stabilizedThis = array.map((el, index) => [el, index]);
    stabilizedThis.sort((a, b) => {
      const order = cmp(a[0], b[0]);
      if (order !== 0) return order;
      return a[1] - b[1];
    });
    return stabilizedThis.map((el) => el[0]);
  }

  function getSorting(order, orderBy) {
    return order === 'desc' ? (a, b) => desc(a, b, orderBy) : (a, b) => -desc(a, b, orderBy);
  }

  const headCells = [
    {
        id: 'userName',
        numeric: false,
        disablePadding: false,
        label: getTranslation('User', preferredLanguage),
      },
    // { id: 'priorityFill', numeric: false, disablePadding: true, label: '' },
    // { id: 'dateCreated', numeric: false, disablePadding: false, label: '' },
    // { id: 'filler', numeric: false, disablePadding: false, label: '' },
    // { id: 'filler', numeric: false, disablePadding: false, label: '' },
  ];

  const userHeadCells = [
    //{ id: 'priorityFill', numeric: false, disablePadding: true, label: '' },
    //{ id: 'dateCreated', numeric: false, disablePadding: false, label: 'Date Created' },
    { id: 'trainingThumbnail', numeric: false, disablePadding: false, label: '' },
    {
      id: 'trainingTitle',
      numeric: false,
      disablePadding: false,
      label: getTranslation('Module Title', preferredLanguage),
    },
    {
      id: 'dateAssigned',
      numeric: false,
      disablePadding: false,
      label: getTranslation('Date Assigned', preferredLanguage),
    },
    {
      id: 'dateCompleted',
      numeric: false,
      disablePadding: false,
      label: getTranslation('Date Completed', preferredLanguage),
    },

  ];


  const useHeaderStyles = makeStyles((theme) => ({
    tableHeader: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
     width: '%100',

      '@media(max-width:830px)': {
        fontSize: 10,
        paddingTop: 0,
        paddingBottom: 0,
        //width: 50,
      },
    },
    detailsHeader: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      //width: 50,
      textAlign: 'right',
      '@media(max-width:830px)': {
        fontSize: 10,
        //width: 45,
        padding: 5,
      },
    },
    zeroHeader: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      width: 0,
      padding: 0,
    },
    formControl: {
      width: '100px',
    },
  }));

  function EnhancedTableHead(props) {
    const { classes, onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort } = props;
    const createSortHandler = (property) => (event) => {
      onRequestSort(event, property);
    };

    const headerClasses = useHeaderStyles();

    return (
      <TableHead>
        <TableRow>

        {headCells.map((headCell) => (
            <TableCell
              className={headerClasses.tableHeader}
              key={headCell.id}
              align={headCell.numeric ? 'right' : 'left'}
              padding={headCell.disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCell.id ? order : false}
            >
              <TableSortLabel
                active={orderBy === headCell.id}
                direction={orderBy === headCell.id ? order : 'asc'}
                onClick={createSortHandler(headCell.id)}
              >
                {headCell.label}

                {orderBy === headCell.id ? (
                  <span className={classes.visuallyHidden}>
                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                  </span>
                ) : null}
              </TableSortLabel>
            </TableCell>
          ))}

          {mobileCheck === true ? (
            <TableCell
              className={headerClasses.colorHeader}
              key={headCells[0].id}
              align={headCells[0].numeric ? 'right' : 'left'}
              padding={headCells[0].disablePadding ? 'none' : 'default'}
              sortDirection={orderBy === headCells[0].id ? order : false}
            ></TableCell>
          ) : (
            <TableCell
              className={headerClasses.zeroHeader}
              key={headCells[0].id}
              align={headCells[0].numeric ? 'right' : 'left'}
              //padding={headCells[0].disablePadding ? 'none' : 'default'}
              //sortDirection={orderBy === headCells[0].id ? order : false}
            ></TableCell>
          )}

          {/* <TableCell className={headerClasses.detailsHeader}>{getTranslation('Details', preferredLanguage)}</TableCell> */}
        </TableRow>
      </TableHead>
    );
  }

  EnhancedTableHead.propTypes = {
    classes: PropTypes.object.isRequired,
    numSelected: PropTypes.number.isRequired,
    onRequestSort: PropTypes.func.isRequired,
    onSelectAllClick: PropTypes.func.isRequired,
    order: PropTypes.oneOf(['asc', 'desc']).isRequired,
    orderBy: PropTypes.string.isRequired,
    rowCount: PropTypes.number.isRequired,
  };

  const useToolbarStyles = makeStyles((theme) => ({
    root: {
      //paddingLeft: theme.spacing(2),
      //paddingRight: theme.spacing(1),
      '@media(max-width:830px)': {
        height: '25px',
      },
    },
    highlight:
      theme.palette.type === 'light'
        ? {
            color: theme.palette.secondary.main,
            backgroundColor: lighten(theme.palette.secondary.light, 0.85),
          }
        : {
            color: theme.palette.text.primary,
            backgroundColor: theme.palette.secondary.dark,
          },
    title: {
      fontFamily: 'Montserrat, sans-serif',
      fontWeight: 600,
      flex: '1 1 100%',
    },
    icons: {
      '@media(max-width:830px)': {
        fontSize: 25,
      },
    },
    sortSelect: {
      width: '100px',
      marginRight: '40px',
    },
  }));

  const EnhancedTableToolbar = (props) => {
    const classes = useToolbarStyles();
    const { numSelected } = props;

    return (
      <Toolbar
        className={clsx(classes.root, {
          [classes.highlight]: numSelected > 0,
        })}
      >
        {numSelected > 0 ? (
          <Typography className={classes.title} color="inherit" variant="subtitle1">
            {numSelected} {getTranslation('selected', preferredLanguage)}
          </Typography>
        ) : (
          <Typography className={classes.title} variant="h6" id="tableTitle"></Typography>
        )}

        {/* <Tooltip title={getTranslation('Sort By', preferredLanguage)}>
          <IconButton className={classes.icons} onClick={refreshTable} aria-label="delete">
            <SortIcon fontSize="inherit" />
          </IconButton>
        </Tooltip> */}

        <FormControl>
          <Tooltip title={getTranslation('Sort By', preferredLanguage)}>
            <Select
              className={classes.sortSelect}
              labelId="select-sort-by"
              value={sortByProperty}
              onChange={handleSortByChange}
              IconComponent={SortIcon}
            >
              <MenuItem value={'userName'}>{getTranslation('User', preferredLanguage)}</MenuItem>
              <MenuItem value={'trainingModuleId'}>{getTranslation('Module', preferredLanguage)}</MenuItem>
              <MenuItem value={'alertType'}>{getTranslation('Progress', preferredLanguage)}</MenuItem>
            </Select>
          </Tooltip>
        </FormControl>



      </Toolbar>
    );
  };

  EnhancedTableToolbar.propTypes = {
    numSelected: PropTypes.number.isRequired,
  };

  const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
      '@media(max-width:600px)': {
        width: '80%',
      },
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
      fontFamily: 'Montserrat, sans-serif',
    },
    container: {
      maxHeight: 500,
      '@media(max-width:600px)': {
        maxHeight: '200px',
      },
    },
    table: {
      minWidth: 750,
      '@media(max-width:820px)': {
        minWidth: 550,
      },
    },
    tableCell: {
      fontFamily: 'Montserrat, sans-serif',
      width: '100%',
    //   paddingLeft: 6,
    //   paddingRight: 6,
      '@media(max-width:820px)': {
        fontSize: '.75rem',
      },
    },
    tableRow: {
      paddingLeft: 0,
      width: '100%'
    },
    detailsCell: {
      fontFamily: 'Montserrat, sans-serif',
      width: 80,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    headerCell: {
      width: '100%',
    },
  }));

  const classes = useStyles();
  const [order, setOrder] = React.useState('desc');
  const [orderBy, setOrderBy] = React.useState('createDate');

  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(false);
  const [rowsPerPage, setRowsPerPage] = React.useState(rows.length);

  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'desc';
    setOrder(isAsc ? 'asc' : 'desc');
    setOrderBy(property);
  };

  function extractAlertIds(array) {
    // Map each object in the array to its alertId property
    return array.map((item) => item.alertId);
  }

  const handleSelectAllClick = (event) => {
    event.stopPropagation();
    if (event.target.checked) {
      const newSelecteds = extractAlertIds(alertsData);

      setSelected(newSelecteds);

      return;
    } else {
      setSelected([]);
    }
  };




  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const emptyRows = rowsPerPage - Math.min(rowsPerPage, rows.length - page * rowsPerPage);

  const clientId = props.clientId;



  function getObjectFromArray(array) {
    // Check if the array has at least one element
    if (array.length > 0) {
      // Return the first element of the array
      return array[0];
    } else {
      // If the array is empty, return null or handle the error accordingly
      return null;
    }
  }

  // Example usage:
  const array = [{ key: 'value' }];

  function stringExistsInArray(array, searchString) {
    // Use the includes method to check if the array contains the searchString
    return array.includes(searchString);
  }

  function compareArrays(array1, array2) {
    return array2.every((item) => array1.includes(item));
  }

  const [open, setOpen] = useState(false);

  const handleToggleCollapse = (event, index) => {
    setOpen((prevOpen) => (prevOpen === index ? null : index));
    //event.stopPropagation();
  };

  const isSelected = (alert) => selected.indexOf(alert) !== -1;

  function transformTrainingData(data) {
    // Initialize an empty array to store the transformed data
    let transformedData = [];

    // Iterate over each object in the input array
    data.forEach((obj) => {
      // Iterate over each array within the object
      ['trainingCoursesAssigned', 'trainingCoursesInProgress', 'trainingCoursesCompleted'].forEach((status) => {
        obj[status].forEach((course) => {
          // Create a new object with the required keys and values
          let newObj = {
            trainingModuleId: course.trainingModuleId,
            // Copy other keys and values from the course object
            ...course,
            // Add the "status" key with the appropriate value
            status: status.replace('trainingCourses', '').toLowerCase(),
          };
          // Push the new object to the transformedData array
          transformedData.push(newObj);
        });
      });
    });

    return transformedData;
  }

  function getTitleAndThumbnailById(data, id) {
    // Find the object in the array that matches the given id
    const foundObj = data.find((obj) => obj.modId === id);

    // If object is found, return an object with "title" and "thumbnail" values
    if (foundObj) {
      return {
        title: foundObj.title,
        thumbnail: foundObj.thumbnail,
      };
    } else {
      // If no matching object is found, return null
      return null;
    }
  }

  const id = '6504cfcdf2ae016cfc66f7a9';

  const result = getTitleAndThumbnailById(props.trainingModules?.trainingItems, id);
  //console.log(result);

  let trainingItems = props.trainingModules?.trainingItems;

  function Row(props) {
    const { initialRow, index } = props;

    const classes = useStyles();
    const labelId = `enhanced-table-checkbox-${index}`;
    let row = initialRow;
    const transformedData = transformTrainingData(row.data);
    //console.log(transformedData);

    const rowAlertIds = row.data.map((obj) => obj['alertId']);

    return (
      <React.Fragment>
        <TableRow
          hover
          className={classes.tableRow}
          //onClick={event => handleClick(event, row.alertId)}
          //role="checkbox"
          //aria-checked={isItemSelected}
          tabIndex={-1}
          key={row.alertId}
          selected={compareArrays(
            selected,
            row.data.map((obj) => obj['alertId'])
          )}
          //selected={isItemSelected}
        >
          {/* <TableCell className={classes.tableCell}>
            <Tooltip title={getTranslation('Select Group', preferredLanguage)}>
              <Checkbox
                checked={compareArrays(selected, rowAlertIds)}
                inputProps={{ 'aria-labelledby': labelId }}
                onClick={(event) => handleGroupClick(event, row.data)}
              />
            </Tooltip>
          </TableCell> */}
          <TableCell width={'auto'} className={classes.tableCell}>{accountForUserLength(row.username)}</TableCell>

          <TableCell TableCell align="right" className={classes.tableCell}>
            <IconButton aria-label="expand row" size="small" onClick={(event) => handleToggleCollapse(event, index)}>
              {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
            </IconButton>
          </TableCell>
        </TableRow>
        <TableRow>
          <TableCell style={{ padding: 0 }} colSpan={6}>
            <Collapse in={open === index} timeout="auto" unmountOnExit>
              <Box margin={0}>
                <Table aria-label="alerts">
                  {/* <EnhancedTableHead
                    classes={classes}
                    numSelected={selected.length}
                    order={order}
                    orderBy={orderBy}
                    onSelectAllClick={handleSelectAllClick}
                    onRequestSort={handleRequestSort}
                    rowCount={rows.length}
                  />
                   <TableHead className={classes.headerCell}> */}
                   <TableHead>
              <TableRow>
                {/* <TableCell style={{ paddingLeft: '6px' }} className={classes.headerCell}>
                  <Tooltip title={getTranslation('Select All', preferredLanguage)}>
                    <Checkbox onClick={handleSelectAllClick} />
                  </Tooltip>
                </TableCell> */}
                <TableCell style={{ paddingLeft: '6px' }} className={classes.headerCell}>
                  {sortByProperty === 'userName' ? '' : "TBD"}
                </TableCell>
                
                <TableCell style={{ paddingLeft: '6px', fontWeight: 600 }} className={classes.headerCell}>
                  {sortByProperty === 'userName' ? getTranslation('Module Title', preferredLanguage) : "TBD"}
                </TableCell>
                <TableCell style={{ paddingLeft: '6px', fontWeight: 600 }} className={classes.headerCell}>
                  {sortByProperty === 'userName' ? getTranslation('Date Assigned', preferredLanguage) : "TBD"}
                </TableCell>
                <TableCell style={{ paddingLeft: '6px', fontWeight: 600 }} className={classes.headerCell}>
                  {sortByProperty === 'userName' ? getTranslation('Date Completed', preferredLanguage) : "TBD"}
                </TableCell>

                {/* <TableCell style={{ paddingLeft: '6px' }} className={classes.headerCell}>
                  {sortByProperty === 'trainingModuleId' ? 'Module Title' : 'TBD'}
                </TableCell> */}

              </TableRow>
            </TableHead>
                  <TableBody>
                    {transformedData.map((dataRow) => (
                      <TableRow
                        key={dataRow.alertId}
                        hover
                        className={classes.tableRow}
                        //onClick={event => handleClick(event, row.alertId)}
                        role="checkbox"
                        aria-checked={stringExistsInArray(selected, dataRow.alertId)}
                        tabIndex={-1}
                        selected={stringExistsInArray(selected, dataRow.alertId)}
                      >
                        {/* <TableCell align="left" className={classes.tableCell}>
                          {getTranslation(dataRow.incidentType, preferredLanguage)}
                        </TableCell> */}

                        <TableCell className={classes.tableCell}>
                          <img
                            style={{ width: '150px', padding: "0px" }}
                            src={getTitleAndThumbnailById(trainingItems, dataRow.trainingModuleId)?.thumbnail}
                          ></img>
                        </TableCell>

                        <TableCell className={classes.tableCell}>
                          {getTitleAndThumbnailById(trainingItems, dataRow.trainingModuleId)?.title}
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <DateCreateTimeStamp date={dataRow.assignedDate} />
                        </TableCell>
                        <TableCell className={classes.tableCell}>
                          <DateCreateTimeStamp date={dataRow.completedDate} />
                        </TableCell>

                        {/* <TableCell align="left" className={classes.tableCell}>
                          {getTranslation(dataRow.incidentType, preferredLanguage)}
                        </TableCell> */}

                        {/* <TableCell align="right" className={classes.detailsCell}>
                          {' '}
                          <IconButton
                            onClick={() => alertDetailPush(`/AlertsDetail?pad=&id=${dataRow.alertId}`)}
                            aria-label="details"
                          >
                            <MoreHorizIcon />
                          </IconButton>
                        </TableCell> */}
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </Box>
            </Collapse>
          </TableCell>
        </TableRow>
      </React.Fragment>
    );
  }

  return (
    <div className={classes.root}>
      <Paper className={classes.paper}>
        {/* <EnhancedTableToolbar numSelected={selected.length} /> */}
        <TableContainer className={classes.container}>
          <Table
          style={{ width: "auto", tableLayout: "auto" }}
            stickyHeader
            className={classes.table}
            aria-labelledby="tableTitle"
            size={dense ? 'small' : 'medium'}
            aria-label="enhanced table"
          >
            <EnhancedTableHead
              classes={classes}
              numSelected={selected.length}
              order={order}
              orderBy={orderBy}
              onRequestSort={handleRequestSort}
              rowCount={rows.length}
            />
            {/* <TableHead className={classes.headerCell}>
              <TableRow>
                {/* <TableCell style={{ paddingLeft: '6px' }} className={classes.headerCell}>
                  <Tooltip title={getTranslation('Select All', preferredLanguage)}>
                    <Checkbox onClick={handleSelectAllClick} />
                  </Tooltip>
                </TableCell> */}
                {/* <TableCell style={{ paddingLeft: '6px' }} className={classes.headerCell}>
                  {sortByProperty === 'userName' ? 'User' : sortByProperty}
                </TableCell> */}

                {/* <TableCell style={{ paddingLeft: '6px' }} className={classes.headerCell}>
                  {sortByProperty === 'trainingModuleId' ? 'Module Title' : 'TBD'}
                </TableCell> */}

                {/* <TableCell style={{ paddingLeft: '6px' }} className={classes.headerCell}></TableCell>
              </TableRow>
            </TableHead>  */} 

            <TableBody>
              {stableSort(rows, getSorting(order, orderBy))
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row, index) => {
                  const isItemSelected = isSelected(row.data.alertId);
                  const labelId = `enhanced-table-checkbox-${index}`;

                  return <Row key={row.data.userName} initialRow={row} index={index} />;
                })}
              {emptyRows > 0 && (
                <TableRow style={{ height: (dense ? 33 : 53) * emptyRows }}>
                  <TableCell colSpan={4} />
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>

        <TablePagination
          rowsPerPageOptions={[10, 25, 50, rows.length]}
          component="div"
          count={rows.length}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          className={classes.tableCell}
        />
      </Paper>
    </div>
  );
};
export default AdminTrainingTableCollapsible;
